import { gql } from '@apollo/client';
const ADD_MODEL_SPECIFICATION_STATUS = gql `
  mutation AddModelSpecificationStatus(
    $namePL: String!
    $nameEN: String!
    $color: ModelSpecificationStatusColor!
  ) {
    addModelSpecificationStatus(namePL: $namePL, nameEN: $nameEN, color: $color) {
      status {
        id
        namePL
        nameEN
        color
        canBeUpdated
        canBeRemoved
      }
    }
  }
`;
export default ADD_MODEL_SPECIFICATION_STATUS;
